// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__olr34","table-of-contents":"table-of-contents__cKkGp"};